/* eslint-disable import/no-extraneous-dependencies */
import 'core-js/es/object/values';
import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'airbnb-browser-shims';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import 'element-remove';
import FloatingVue from 'floating-vue';
import VueInsProgressBar from 'vue-ins-progress-bar';
import * as he from 'he';

import { config, library } from '@fortawesome/fontawesome-svg-core';
import {
    faExclamationTriangle,
    faCircleMinus,
    faLinkSlash,
    faRotateRight,
    faSpinner,
    faPersonToDoor,
    faPersonWalkingArrowRight,
    faCaretUp,
    faCaretDown,
    faTrainSubway,
    faCheckSquare,
    faArrowDownArrowUp,
    faArrowRightArrowLeft,
    faSterlingSign,
    faClock,
    faStar,
    faXmark,
    faSpinnerThird,
    faCheck,
} from '@fortawesome/pro-solid-svg-icons';
import { faInfoCircle, faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import addSpinEventListeners from './spin-on-click';
import ProgressIndicator from './components/ProgressIndicator';
import DisruptionsTable from './components/DisruptionsTable';
import BottomBanner from './components/BottomBanner';

config.autoAddCss = false;
library.add(
    faExclamationTriangle,
    faCircleMinus,
    faLinkSlash,
    faRotateRight,
    faSpinner,
    faPersonToDoor,
    faPersonWalkingArrowRight,
    faCaretUp,
    faCaretDown,
    faCalendar,
    faTrainSubway,
    faInfoCircle,
    faCheckSquare,
    faArrowDownArrowUp,
    faArrowRightArrowLeft,
    faSterlingSign,
    faClock,
    faStar,
    faXmark,
    faSpinnerThird,
    faCheck,
);

/* Google Analytics */
/* eslint-disable */
window.dataLayer = window.dataLayer || [];
const gaTrackingId = document.querySelector('meta[name=brand-ua-tracking-id]').content;
function gtag() { dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', gaTrackingId);
if (typeof (ga) !== 'undefined') {
    ga('set', 'allowAdFeatures', false);
}
window.gtag = gtag;
/* eslint-enable */

if ('msCrypto' in window) {
    window.crypto = window.msCrypto;
}

const sentryConfig = {
    Vue,
    dsn: process.env.SENTRY_FRONTEND_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
        // Google ReCAPTCHA
        if (hint.originalException === 'Timeout' || hint.originalException === 'Timeout (n)') return null;
        // Browser extensions
        if (event.extra && event.extra.body && event.extra.body.sourceFile
            && (event.extra.body.sourceFile.startsWith('safari-web-extension')
                || event.extra.body.sourceFile.startsWith('safari-extension')
                || event.extra.body.sourceFile.startsWith('chrome-extension')
                || event.extra.body.sourceFile.startsWith('moz-extension'))) return null;
        return event;
    },
    ignoreErrors: [
        // Google ReCAPTCHA
        'Non-Error promise rejection captured with value: null',
        // private browsing / incognito mode - sessionStorage, localStorage
        'Access is denied for this document',
        // ResizeObserver
        'ResizeObserver',
        // Bing tracking
        'Cannot read property \'domContentLoadedEventEnd\' of undefined',
        // Beacon errors with loading
        'ChunkLoadError',
        // Microsoft are idiots
        'Non-Error promise rejection captured with value: Object Not Found Matching Id',
    ],
};

const gitSha = document.querySelector('meta[name=sha]').getAttribute('content');
if (gitSha !== 'unknown') {
    sentryConfig.release = gitSha;
}

if (document.location.hostname !== 'localhost') {
    Sentry.init(sentryConfig);
}

Vue.config.warnHandler = (err, vm, info) => {
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in. Only available in 2.2.0+
    Sentry.captureException(new Error(`Vue warning observed: ${err}`), { extra: { info } });
};

require('../css/app.scss');
require('../css/_colours.scss');
const $ = require('jquery');
require('jquery-ui/dist/jquery-ui');
require('bootstrap');
require('./jquery.makevueapp');
const padStart = require('string.prototype.padstart');

padStart.shim();

// create global $ and jQuery variables
global.$ = $;
global.jQuery = $;
window.firebase_project_id = 'trainsplit';
FloatingVue.options.themes.tooltip.html = true;
Vue.use(FloatingVue);
const options = {
    position: 'fixed',
    show: true,
    height: '6px',
};

Vue.use(VueInsProgressBar, options);

/* eslint-disable-next-line vue/component-definition-name-casing */
Vue.component('font-awesome-icon', FontAwesomeIcon);

if (document.querySelectorAll('#progress').length > 0) {
    window.progressIndicator = new (Vue.extend(ProgressIndicator))({
        el: '#progress',
    });
}

// Default callbacks from firebaseUI sign-in, can be overridden if needed
window.firebaseUiCallbacks = {
    handleSignInSuccess() {
        $('#signInModal')
            .modal('hide');
        return false;
    },
    handleSignInFailureNonMergeConflict() {
        // todo: handle other authentication errors?
        $('#signInModal')
            .modal('hide');
        return Promise.resolve();
    },
    handleSignInFailureAnonymousMergeConflict(error) {
        // The credential the user tried to sign in with.
        const cred = error.credential;

        // The previous (anonymous) user
        const prevUser = firebase.auth().currentUser;
        let oldToken = null;
        prevUser.getIdToken(false)
            .then((token) => {
                oldToken = token;
                // Complete sign-in as per https://github.com/firebase/firebaseui-web#upgrading-anonymous-users
                return firebase.auth()
                    .signInAndRetrieveDataWithCredential(cred);
            })
            .then((userCredential) => userCredential.user.getIdToken(false))
            .then((newToken) => fetch('/account/associateBookings', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    projectId: window.firebase_project_id,
                    oldToken,
                    newToken,
                }),
            }))
            .catch((errors) => {
                // ignore errors?
                Sentry.captureException(errors);
            })
            .finally(() => {
                $('#signInModal')
                    .modal('hide');
                return Promise.resolve();
            });
    },
};

window.firebaseUiConfig = {
    callbacks: {
        signInSuccessWithAuthResult() {
            // User successfully signed in. This will not trigger on merge conflicts.
            return window.firebaseUiCallbacks.handleSignInSuccess();
        },
        signInFailure(error) {
            // Some unrecoverable error occurred during sign-in.
            // Return a promise when error handling is completed and FirebaseUI
            // will reset, clearing any UI. This commonly occurs for error code
            // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
            // occurs.
            if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
                return window.firebaseUiCallbacks.handleSignInFailureNonMergeConflict(error);
            }
            return window.firebaseUiCallbacks.handleSignInFailureAnonymousMergeConflict(error);
        },
        uiShown() {
            // The widget is rendered.
            // Hide the loader.
            if (document.getElementById('modal-loader')) {
                document.getElementById('modal-loader').style.display = 'none';
            }
        },
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: 'popup',
    signInSuccessUrl: 'basket',
    signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.GithubAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    // Automatically upgrade anonymous user accounts when login with permanent account - user.uid will remain same unless
    // there is a merge conflict which needs to be handled in handleUIError
    autoUpgradeAnonymousUsers: true,
    // Disable the default credentialHelper, accountchooser.com, as it's redirect method doesn't work with our modal.
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    // TODO: We can also provide privacy & tos urls which will appear beneath the firebaseui buttons
    // Terms of service url.
    // tosUrl: 'https://trainsplit.com/static/tsandcs.html',
    // Privacy policy url.
    // privacyPolicyUrl: 'privacy',
};

const myDefaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
myDefaultWhiteList.button = [];

let bottomBannerApp;

$(() => {
    bottomBannerApp = $('#bottom-banner-app');
    if (bottomBannerApp.length) {
        bottomBannerApp = bottomBannerApp.makeVueApp(
            {
                components: {
                    BottomBanner,
                },
            },
        );
    }

    $('.feedback')
        .click(() => {
            window.Beacon('open');
        });

    if (typeof (firebase) !== 'undefined') {
        // Initialize Firebase
        const firebaseConfig = {
            apiKey: 'AIzaSyA8qxNJSkbiqDhyDbT-CHG_YZML7W--q58',
            authDomain: 'trainsplit.firebaseapp.com',
            databaseURL: 'https://trainsplit.firebaseio.com',
            projectId: window.firebase_project_id,
            storageBucket: 'trainsplit.appspot.com',
            messagingSenderId: '5800411061',
        };
        firebase.initializeApp(firebaseConfig);
        firebase.auth()
            .onAuthStateChanged((user) => {
                if (window.Beacon && user && !user.isAnonymous) {
                    if (user && user.uid === 'For8wRslORd3JoGPiu809iIt9zx2') {
                        Sentry.captureException(new Error('Found a ninja trying to pay, educating them'));
                        window.location = 'https://rail.ninja';
                    }
                    window.BeaconSessionData = {
                        'firebase-uid': user.uid,
                        'firebase-email': user.email,
                        ...window.BeaconSessionData,
                    };
                    window.Beacon('session-data', window.BeaconSessionData);
                    window.Beacon('prefill', {
                        email: user.email,
                    });
                }
            });
        if (document.querySelector('#force-firebase')) {
            let authUI = firebaseui.auth.AuthUI.getInstance();
            if (!authUI) {
                // Initialize the FirebaseUI Widget using Firebase.
                authUI = new firebaseui.auth.AuthUI(firebase.auth());
            }
            firebase.auth().onAuthStateChanged((user) => {
                const isAuthorised = user && !user.isAnonymous;
                if (isAuthorised) {
                    user.getIdToken().then((token) => {
                        fetch('/brand/firebase', {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            credentials: 'same-origin',
                            body: JSON.stringify({
                                projectId: window.firebase_project_id,
                                token,
                            }),
                        }).then((r) => {
                            if (r.status === 200) {
                                window.location = document.getElementById('force-firebase').getAttribute('data-next');
                            } else {
                                r.json().then((t) => {
                                    if (t.shouldVerifyEmail) {
                                        const currentUrl = new URL(window.location.href);
                                        currentUrl.searchParams.append('backFromVerify', 'true');
                                        firebase.auth().currentUser.sendEmailVerification({
                                            url: window.location.href,
                                        }).catch((e) => {
                                            Sentry.captureException(e);
                                        });
                                        jQuery('#instruction').text('Please re-authenticate once email is verified:');
                                    } else {
                                        jQuery('#instruction').text('Try a different sign-in method:');
                                    }

                                    firebase.auth()
                                        .signOut().then(() => {
                                            authUI.start('#firebaseui-auth-container', window.firebaseUiConfig);
                                        });

                                    jQuery('#alertInner').addClass('red');
                                    jQuery('#alertMsg').text('Something went wrong');
                                    jQuery('#alertBody').text(t.error);
                                });
                            }
                        });
                    });
                }
            });
            // The start method will wait until the DOM is loaded.
            authUI.start('#firebaseui-auth-container', window.firebaseUiConfig);
        }
    }
    const expandContainer = (el, toggle = true) => {
        const container = $(el).parent();

        const img = container.find('img.chevron');
        if (toggle) {
            container.find('.detail').toggleClass('d-none');
            container.toggleClass('expanded');
        } else {
            container.find('.detail').removeClass('d-none');
            if (!container.hasClass('expanded')) {
                container.addClass('expanded');
            }
        }

        const imgSrc = img.attr('src');
        if (container.hasClass('expanded')) {
            img.attr('src', imgSrc.replace('down', 'up'));
        } else {
            img.attr('src', imgSrc.replace('up', 'down'));
        }
    };

    $('.disruptions-table').each((i, el) => {
        const data = JSON.parse(he.decode(document.querySelector('#widespreadDisruptions').innerHTML));
        // eslint-disable-next-line no-new
        new (Vue.extend(DisruptionsTable))({
            el,
            propsData: {
                disruptions: data,
            },
        });
    });

    $(document).ready(() => $('.expanding-container.expanded > div:first-child')
        .each((i, el) => expandContainer(el, false)));
    $(document).on(
        'click',
        '.expanding-container > div:first-child',
        (event) => expandContainer(event.currentTarget),
    );

    if ($('#your-tickets').length > 0) {
        document.addEventListener('visibilitychange', () => {
            if (document.hidden && $('.tlist-container.expanded  > div:first-child').length > 0) {
                expandContainer($('.tlist-container.expanded  > div:first-child')[0], true);
                $('.modal').modal('hide');
            }
        });
    }

    addSpinEventListeners();

    if (window.location.search.includes('aff=')) {
        const params = new URLSearchParams(window.location.search);
        window.sessionStorage.setItem('aff', params.get('aff'));
    }

    if (window.sessionStorage.getItem('aff')) {
        const argonHomepageLink = document.getElementById('argonHomepageLink');
        const url = new URL(argonHomepageLink.href);
        url.searchParams.set('aff', window.sessionStorage.getItem('aff'));
        argonHomepageLink.setAttribute('href', url.toString());
    }
});

/* HelpScout Beacon */
/* eslint-disable */
if (!document.body.classList.contains('embeddablejp') && !document.body.classList.contains('login')) {
    window.BeaconSessionData = {};
    !(((e, t) => {
        (window.Beacon = t = (e, t, n) => {
            window.Beacon.readyQueue.push({ method: e, options: t, data: n });
        });
        t.readyQueue = [];
        const n = e.getElementsByTagName('script')[0];
        const o = e.createElement('script');
        o.type = 'text/javascript';
        o.async = !0;
        o.src = 'https://beacon-v2.helpscout.net';
        n.parentNode.insertBefore(o, n);
    })(document, window.Beacon || (() => {})));

    window.Beacon('init', '150b00d7-d607-4aa7-92c0-95c3e73784ab');
    window.Beacon('prefill', {
        name: '',
        email: '',
        subject: '',
        text: '',
    });
}
/* eslint-enable */
